export const actionTypes = {
    getValidationResult: "[adstxt] Validation result",
};

export const mutationTypes = {
    adstxtValidationStart: "[adstxt] Validation start",
    adstxtValidationSuccess: "[adstxt] Validation success",
    adstxtValidationFailure: "[adstxt] Validation failure",
};

export const getterTypes = {
    getAdstxtValidationResult: "[adstxt] Get Validation adstxt result",
    getError: "[adstxt] Get error",
    isLoading: "[adstxt] Get isLoading",
};
